module.exports = __webpack_public_path__ + "img/blue-point-inactive.c1d83a00.svg";